import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import useVerifyEmail from '../../hooks/useVerifyEmail';

import NotificationPanel from '../partials/NotificationPanel';

import styles from '../../../styles/notifications/notifications.module.scss';

const propTypes = {
    className: PropTypes.string,
};

const defaultProps = {
    className: null,
};

const ConfirmEmail = ({ className }) => {
    const { success, loading, verifyEmail } = useVerifyEmail();

    return (
        <div
            className={classNames(styles.container, {
                [className]: className !== null,
            })}
        >
            <NotificationPanel
                className={styles.notification}
                loading={loading}
                onClick={!success ? verifyEmail : null}
                active={!success}
                rounded
                label={
                    <FormattedMessage
                        defaultMessage="To rent online movies you must verify your email address. Check your inbox and click on the link inside to confirm."
                        description="Message"
                    />
                }
                buttonLabel={
                    success ? (
                        <FormattedMessage
                            defaultMessage="The confirmation email was sent! Check your inbox."
                            description="Message"
                        />
                    ) : (
                        <FormattedMessage
                            defaultMessage="Click here to send a new confirmation email."
                            description="Message"
                        />
                    )
                }
            />
        </div>
    );
};

ConfirmEmail.propTypes = propTypes;
ConfirmEmail.defaultProps = defaultProps;

export default ConfirmEmail;
